(function () {
  const KEY = 'kk2_recently_viewed_v1';
  const MAX = 12;

  function getViewed() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function track(product) {
    if (!product || !product.id) return;
    let list = getViewed().filter((p) => p.id !== product.id);
    list.unshift(product);
    list = list.slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  window.KK2SocialProof = {
    getViewed: getViewed,
    track: track,
  };
})();
